import { Helmet } from 'react-helmet-async';

/**
 * The head of an application page. Any seo tag/meta-tag should be handled in this context.
 */
function PageHead({ title, description, robots = 'index, follow', children }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      {children}
    </Helmet>
  );
}

PageHead.displayName = 'PageHead';
export { PageHead };
